// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".icon-button[data-v-73cf5239]{position:absolute;top:0;right:0}.small[data-v-73cf5239]{width:80px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
